import React, { memo } from 'react'

import { func } from 'prop-types'

import UpgradeCard from '../UpgradeCard/UpgradeCard'

function UpgradeBody({ onClose: handleClose }) {
  return (
    <div className="usage-modal__upgrade">
      <UpgradeCard onClose={handleClose} title="Upgrade to Start Creating" />
    </div>
  )
}

UpgradeBody.propTypes = {
  onClose: func.isRequired,
}

export default memo(UpgradeBody)
